






















import Vue, { PropType } from 'vue';
import { v4 } from 'uuid';
import { FirestoreDate } from '@/modules/firestore';

export default Vue.extend({
  name: 'GDatePickForm',
  props: {
    label: { type: String as PropType<string>, default: null },
    isRequired: { type: Boolean as PropType<boolean>, default: false },
    value: { type: [Date, Object, String] as PropType<FirestoreDate>, default: null },
    name: { type: String as PropType<string>, required: true },
    disabled: { type: Boolean as PropType<boolean>, default: false },
    isRight: { type: Boolean as PropType<boolean>, default: false },
    duplicateError: { type: Boolean as PropType<boolean>, default: false },
    coupleValueError: { type: Boolean as PropType<boolean>, default: false },
    formatError: { type: Boolean as PropType<boolean>, default: false },
    rules: { type: [String, Object] as PropType<string | object>, default: '' },
  },
  computed: {
    vid(): string {
      return `${this.name}:${v4()}`;
    },
    innerValue(): Date | Object | String {
      return this.value;
    },
  },
  methods: {
    selected(date: string): void {
      this.$emit('selected', date);
    },
    validate() {
      (this.$refs.gDatePickerFormProvider as any).validate();
    },
  },
});
